/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarFormsAppStatusChirpUIService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './WebinarFormsAppStatusChirpUIService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarFormsAppStatusChirpUIService#appStatus
 */
export const APP_STATUS_QUERY_FIELD_NAME = 'com_hubspot_video_conference_component_rpc_ui_service_v1_WebinarFormsAppStatusChirpUIService_appStatus';
export const APP_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: APP_STATUS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.appStatusRpc, {
      timeout: ctx.timeout
    });
  }
});